import { MutableRefObject, useEffect, useState } from 'react'

export const useCollapsible = ({
  nodeRef,
  defaultIsCollapsed = true,
  minHeight = 0
}: {
  nodeRef: MutableRefObject<HTMLElement | null>
  defaultIsCollapsed?: boolean
  minHeight?: number
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true)
  const [height, setHeight] = useState(minHeight)

  const setCurrentHeight = (isCollapsed: boolean) => {
    if (!nodeRef.current) {
      throw new Error('Empty node ref')
    }

    if (isCollapsed) {
      setHeight(minHeight)

      return
    }

    setHeight(nodeRef.current.scrollHeight)
  }

  const toggleCollapsed = () => {
    setIsCollapsed((isCollapsed) => {
      setCurrentHeight(!isCollapsed)

      return !isCollapsed
    })
  }

  useEffect(() => {
    setCurrentHeight(defaultIsCollapsed)
    setIsCollapsed(defaultIsCollapsed)
  }, [])

  return {
    isCollapsed,
    height,
    toggleCollapsed
  }
}
